import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema } from "../../primitivesSchema";

const checklistItemDataSchema = sceneObjectDataSchema.extend({
    position: vector3dSchema,
    normal: vector3dSchema.optional(),
    checklistItemId: z.string().nullable().optional(),
});

export default checklistItemDataSchema;
